import React from "react";

export default function PageHeader({ title, subtitle, action, testidPrefix = "page" }) {
  return (
    <div className="flex items-start sm:items-center justify-between gap-4 flex-col sm:flex-row mb-6">
      <div>
        <h1
          className="font-display text-2xl sm:text-3xl font-semibold tracking-tight"
          data-testid={`${testidPrefix}-title`}
        >
          {title}
        </h1>
        {subtitle ? (
          <p className="mt-1 text-sm text-[color:var(--text-2)]" data-testid={`${testidPrefix}-subtitle`}>
            {subtitle}
          </p>
        ) : null}
      </div>
      {action ? <div className="shrink-0">{action}</div> : null}
    </div>
  );
}
